import type { QuestionnaireType } from '@/types/questionnaire';

import type { ParameterLabel } from './types';

export const enQuestionnaireTranslations: {
  questionnaires: Record<QuestionnaireType, ParameterLabel>;
} = {
  questionnaires: {
    amppro: { displayName: 'AMPPRO' },
    berg: { displayName: 'Berg' },
    psfs: { displayName: 'Functional Scale', acronym: 'PSFS' },
    create_psfs: { displayName: 'Create Functional Scale' },
    fall_confidence: { displayName: 'Fear of Falls' },
    fear_of_falls: { displayName: 'Fear of Falls', acronym: 'FoF' },
    fabq: { displayName: 'FABQ' },
    fes: { displayName: 'Falls Efficacy Scale', acronym: 'FES' },
    jdc: { displayName: 'JDC Survey' },
    kinomatic_weekly_questionnaire: { displayName: 'Kinomatic Weekly Questionnaire' },
    kinomatic_questionnaire: { displayName: 'Kinomatic Questionnaire' },
    kinomatic_questionnaire_navigator: { displayName: 'Kinomatic Questionnaire Navigator' },
    lefs: { displayName: 'Lower Extremity Functional Scale', acronym: 'LEFS' },
    oswestry: { displayName: 'Oswestry' },
    pain_function_limitation: { displayName: 'Pain & Function Limitation' },
    plus_m: { displayName: 'Plus-M', acronym: 'PLUS-M' },
    post_six_min_walk_questionnaire: { displayName: 'Post Six Minute Walk Questionnaire' },
    pre_six_min_walk_questionnaire: { displayName: 'Pre Six Minute Walk Questionnaire' },
    sarcf: { displayName: 'SARC-F' },
    vas: { displayName: 'Pain Rating', acronym: 'VAS' },
    womac: { displayName: 'WOMAC' },
    apos: { displayName: 'APOS' },
    tinetti: { displayName: 'Tinetti' },
    sf_36: { displayName: 'SF-36' },
    fullerton_balance: { displayName: 'Fullerton Advanced Balance' },
    hoos_jr: { displayName: 'HOOS, JR.' },
    koos_jr: { displayName: 'KOOS, JR.' },
  },
};

export const questionnaireNameLabels = Object.fromEntries(
  Object.entries(enQuestionnaireTranslations.questionnaires).map(([key, { displayName }]) => [
    key,
    displayName,
  ]),
) as Record<QuestionnaireType, string>;
